const DeviceMenu = () => {
	const hamBurger = document.querySelector('.hamburger');
	const mbnav = document.querySelector('.mbnav');
	if (!hamBurger || !mbnav) return;

	const overlay = mbnav.querySelector('.mbnav__backdrop');
	const header = document.querySelector('header.main-header');
	const mbnavInner = mbnav.querySelector('.mbnav__inner');
	const mbnavMain = mbnav.querySelector('.mbnav__main');

	const updateHeaderHeight = () => {
		if (header) {
			const innerHeader = header.querySelector('.mh-inner-main');
			const rect = innerHeader ? innerHeader.getBoundingClientRect() : header.getBoundingClientRect();
			const h = Math.round(rect.bottom);
			document.documentElement.style.setProperty('--mb-header-h', `${h}px`);
		}
	};

	updateHeaderHeight();

	const updateMenuHeight = (targetPanel) => {
		if (!mbnavInner) return;
		const headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mb-header-h')) || 70;
		const maxAvailable = window.innerHeight - headerH - 24;
		const activeEl = targetPanel || mbnav.querySelector('.mega-menu.is-active, .sub-menu.is-active') || mbnavMain;
		if (activeEl) {
			const contentH = activeEl.scrollHeight;
			if (contentH > 0) {
				const finalH = Math.min(contentH, maxAvailable);
				mbnavInner.style.height = `${finalH}px`;
			}
		}
	};

	window.addEventListener('resize', () => {
		updateHeaderHeight();
		if (mbnav.classList.contains('is-open')) {
			updateMenuHeight();
		}
	});

	const resetSubmenus = (updateHeight = true) => {
		mbnav.classList.remove('is-sub-open');
		const activePanels = mbnav.querySelectorAll('.mega-menu.is-active, .sub-menu.is-active');
		activePanels.forEach((sub) => sub.classList.remove('is-active'));
		if (updateHeight) {
			requestAnimationFrame(() => {
				updateMenuHeight(mbnavMain);
			});
		}
	};

	const menuClose = () => {
		hamBurger.classList.remove('is-clicked');
		document.body.classList.remove('scroll-fixed');
		mbnav.classList.remove('is-open');
		if (header) header.classList.remove('is-open');
		setTimeout(() => {
			resetSubmenus(false);
			if (mbnavInner) mbnavInner.style.height = '';
		}, 350);
	};

	const menuOpen = () => {
		updateHeaderHeight();
		hamBurger.classList.add('is-clicked');
		mbnav.classList.add('is-open');
		if (header) header.classList.add('is-open');
		document.body.classList.add('scroll-fixed');
		requestAnimationFrame(() => {
			updateMenuHeight(mbnavMain);
		});
	};

	hamBurger.addEventListener('click', (e) => {
		e.preventDefault();
		if (hamBurger.classList.contains('is-clicked')) {
			menuClose();
		} else {
			menuOpen();
		}
	});

	if (overlay) {
		overlay.addEventListener('click', menuClose);
	}

	// Close on Escape
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && mbnav.classList.contains('is-open')) {
			menuClose();
		}
	});

	// Setup drill-down submenus (mega-menu and sub-menu)
	const parentItems = mbnav.querySelectorAll(
		'.mbnav__list > li'
	);

	parentItems.forEach((item) => {
		const link = item.querySelector(':scope > a');
		const subPanel = item.querySelector(':scope > .mega-menu, :scope > .sub-menu');

		if (!subPanel) return;

		// Move subPanel to mbnavInner so it is a direct sibling of mbnav__main.
		// This ensures sliding mbnav__main to the left does not drag subPanel along with it!
		if (mbnavInner && subPanel.parentElement !== mbnavInner) {
			mbnavInner.appendChild(subPanel);
		}

		// If standard .sub-menu has no back button, inject one matching .mega-menu
		if (subPanel.classList.contains('sub-menu') && !subPanel.querySelector('.mm-mobile-back')) {
			const backItem = document.createElement('li');
			backItem.className = 'mm-mobile-back';
			backItem.innerHTML = `
				<button type="button" class="mm-back-btn" aria-label="Back to main menu">
					<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><use xlink:href="#icon-left-menu"></use></svg>
					<span>Main Menu</span>
				</button>
			`;
			subPanel.prepend(backItem);
		}

		// Create or reuse dedicated tap-friendly arrow button
		let arrowBtn = item.querySelector(':scope > .mbnav__arrow-btn');
		if (!arrowBtn) {
			arrowBtn = document.createElement('button');
			arrowBtn.type = 'button';
			arrowBtn.className = 'mbnav__arrow-btn';
			arrowBtn.setAttribute('aria-label', 'Open submenu');
			arrowBtn.innerHTML = '<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><use xlink:href="#icon-right-arrow-cropped"></use></svg>';

			if (link) {
				link.insertAdjacentElement('afterend', arrowBtn);
			} else {
				item.prepend(arrowBtn);
			}
		} else {
			arrowBtn.innerHTML = '<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><use xlink:href="#icon-right-arrow-cropped"></use></svg>';
		}

		const openSubPanel = (e) => {
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
			resetSubmenus(false);
			subPanel.classList.add('is-active');
			mbnav.classList.add('is-sub-open');
			subPanel.scrollTop = 0;
			requestAnimationFrame(() => {
				updateMenuHeight(subPanel);
			});
		};

		// Click on arrow button opens submenu drill-down
		arrowBtn.addEventListener('click', openSubPanel);

		// If link has placeholder ('#' or 'javascript:;'), clicking link also opens
		if (link) {
			const href = link.getAttribute('href');
			const isPlaceholder = !href || href === '#' || href === 'javascript:;' || href.startsWith('#');

			if (isPlaceholder) {
				link.addEventListener('click', openSubPanel);
			}
		}
	});

	// Back buttons inside mega menu drill-downs
	const backButtons = mbnav.querySelectorAll('.mm-back-btn, .mbnav__back-btn');
	backButtons.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			resetSubmenus(true);
		});
	});
};

export default DeviceMenu;
